<template>
  <div v-if="!!tagDiscount">
    <div>
      <p class="price-item">
        <span class="price-item-discounted js-product-price">{{ currencySymbol }}{{ discountedPrice }}</span>
        <s class="price-item-original">{{ currencySymbol }}{{ variantPrice }}</s>
      </p>
      <p class="price-item price-item--red">
        Save {{ tagDiscount }}%
      </p>
    </div>
    <p class="afterpay-paragraph" v-if="purchaseType === 'onetime'">
      or 4 interest-free payments of {{ currencySymbol }}{{ splitVariantPrice }}
      with
      <a
        class="afterpay-logo"
        title="Afterpay - how it works - Opens on a new tab"
        href="https://www.afterpay.com/en-US/how-it-works"
        target="_blank"
        rel="noopener"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="14 12 76 12"
          width="75"
        >
          <path
            fill="transparent"
            d="M86.002 35.932h-68C8.096 35.932.07 27.905.07 18.002.07 8.096 8.097.07 18.001.07h68c9.904 0 17.932 8.027 17.932 17.931.006 9.897-8.028 17.931-17.931 17.931z"
            class="afterpay-logo-badge-background"
          />
          <g class="afterpay-logo-badge-lockup">
            <path
              d="m88.23 13.52-2.259-1.292-2.291-1.313c-1.515-.868-3.409.222-3.409 1.972v.294c0 .163.085.314.229.392l1.064.607c.294.17.66-.045.66-.385v-.699a.45.45 0 0 1 .672-.391l2.09 1.201 2.082 1.195c.3.17.3.607 0 .777l-2.083 1.195-2.089 1.201a.45.45 0 0 1-.673-.391v-.347c0-1.75-1.893-2.846-3.408-1.971l-2.292 1.312-2.26 1.293c-1.52.875-1.52 3.075 0 3.95l2.26 1.293 2.292 1.313c1.515.868 3.408-.222 3.408-1.972v-.294a.442.442 0 0 0-.228-.392l-1.064-.607a.441.441 0 0 0-.66.385v.699a.45.45 0 0 1-.673.392l-2.089-1.202-2.083-1.195a.448.448 0 0 1 0-.777l2.083-1.195 2.09-1.201a.45.45 0 0 1 .672.392v.346c0 1.75 1.894 2.847 3.409 1.972l2.291-1.313 2.26-1.293c1.521-.881 1.521-3.075 0-3.95zM73.408 13.952 68.12 24.876h-2.194l1.979-4.081-3.115-6.843h2.253l1.998 4.584 2.18-4.584h2.188zM20.524 17.83c0-1.306-.947-2.22-2.109-2.22s-2.109.934-2.109 2.22c0 1.274.947 2.22 2.11 2.22s2.108-.914 2.108-2.22m.02 3.879v-1.006c-.575.7-1.43 1.13-2.449 1.13-2.129 0-3.741-1.704-3.741-4.003 0-2.279 1.678-4.015 3.787-4.015.992 0 1.828.437 2.403 1.116v-.98h1.906v7.758h-1.906zM31.723 19.985c-.666 0-.856-.248-.856-.901v-3.441h1.228v-1.691h-1.228v-1.894h-1.952v1.894h-2.52v-.77c0-.654.248-.902.933-.902h.431v-1.502h-.94c-1.613 0-2.377.53-2.377 2.142v1.038h-1.084v1.685h1.084v6.066h1.952v-6.066h2.52v3.8c0 1.58.608 2.266 2.188 2.266h1.006v-1.724h-.385zM38.736 17.132c-.138-1.006-.96-1.613-1.927-1.613-.96 0-1.756.587-1.952 1.613h3.879zm-3.899 1.208c.137 1.149.96 1.802 2.005 1.802.823 0 1.456-.385 1.828-1.006h2.005c-.464 1.646-1.94 2.697-3.879 2.697-2.344 0-3.99-1.645-3.99-3.99 0-2.344 1.737-4.035 4.036-4.035 2.311 0 3.99 1.704 3.99 4.035 0 .17-.013.34-.046.497h-5.949zM53.264 17.83c0-1.253-.947-2.22-2.109-2.22s-2.11.934-2.11 2.22c0 1.274.948 2.22 2.11 2.22s2.11-.96 2.11-2.22m-6.145 7.046V13.952h1.906v1.005c.575-.711 1.43-1.149 2.449-1.149 2.096 0 3.742 1.724 3.742 4.003s-1.679 4.016-3.788 4.016c-.98 0-1.782-.386-2.344-1.039v4.081H47.12v.007zM62.092 17.83c0-1.306-.947-2.22-2.109-2.22s-2.109.934-2.109 2.22c0 1.274.947 2.22 2.11 2.22 1.161 0 2.108-.914 2.108-2.22m.02 3.879v-1.006c-.575.7-1.43 1.13-2.449 1.13-2.128 0-3.741-1.704-3.741-4.003 0-2.279 1.678-4.015 3.787-4.015.992 0 1.828.437 2.403 1.116v-.98h1.907v7.758h-1.907zM43.679 14.71s.483-.902 1.678-.902c.509 0 .835.176.835.176v1.979s-.718-.444-1.377-.353c-.66.092-1.078.692-1.078 1.502v4.59h-1.972v-7.75h1.907v.757h.007z"
            />
          </g>
        </svg>
        <span class="afterpay-info">ⓘ</span>
      </a>
    </p>
  </div>
  <div v-else>
    <div class="price">
      <span
        class="price-item price-item--regular"
        :class="{ 'price-item--red': product.compare_at_price }"
        v-if="purchaseType === 'onetime'"
      >
        <span class="js-product-price">{{ currencySymbol }}{{ variantPrice }}</span>
        <s class="price-item-original"
           v-if="product.compare_at_price"
        >{{ currencySymbol }}{{ compareAtPrice }}</s>
      </span>
      <span
        v-else
        class="price-item price-item--regular js-product-price"
        :class="{ 'price-item--red': purchaseType !== 'onetime' }"
      >{{ currencySymbol }}{{ decimalSubscriptionDiscountedAmount }}
        <s class="price-item-original">{{ currencySymbol }}{{ variantPrice }}</s>
      </span>
    </div>
    <p class="afterpay-paragraph" v-if="purchaseType === 'onetime'">
      or 4 interest-free payments of {{ currencySymbol }}{{ splitVariantPrice }}
      with
      <a
        class="afterpay-logo"
        title="Afterpay - how it works - Opens on a new tab"
        href="https://www.afterpay.com/en-US/how-it-works"
        target="_blank"
        rel="noopener"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="14 12 76 12"
          width="75"
        >
          <path
            fill="transparent"
            d="M86.002 35.932h-68C8.096 35.932.07 27.905.07 18.002.07 8.096 8.097.07 18.001.07h68c9.904 0 17.932 8.027 17.932 17.931.006 9.897-8.028 17.931-17.931 17.931z"
            class="afterpay-logo-badge-background"
          />
          <g class="afterpay-logo-badge-lockup">
            <path
              d="m88.23 13.52-2.259-1.292-2.291-1.313c-1.515-.868-3.409.222-3.409 1.972v.294c0 .163.085.314.229.392l1.064.607c.294.17.66-.045.66-.385v-.699a.45.45 0 0 1 .672-.391l2.09 1.201 2.082 1.195c.3.17.3.607 0 .777l-2.083 1.195-2.089 1.201a.45.45 0 0 1-.673-.391v-.347c0-1.75-1.893-2.846-3.408-1.971l-2.292 1.312-2.26 1.293c-1.52.875-1.52 3.075 0 3.95l2.26 1.293 2.292 1.313c1.515.868 3.408-.222 3.408-1.972v-.294a.442.442 0 0 0-.228-.392l-1.064-.607a.441.441 0 0 0-.66.385v.699a.45.45 0 0 1-.673.392l-2.089-1.202-2.083-1.195a.448.448 0 0 1 0-.777l2.083-1.195 2.09-1.201a.45.45 0 0 1 .672.392v.346c0 1.75 1.894 2.847 3.409 1.972l2.291-1.313 2.26-1.293c1.521-.881 1.521-3.075 0-3.95zM73.408 13.952 68.12 24.876h-2.194l1.979-4.081-3.115-6.843h2.253l1.998 4.584 2.18-4.584h2.188zM20.524 17.83c0-1.306-.947-2.22-2.109-2.22s-2.109.934-2.109 2.22c0 1.274.947 2.22 2.11 2.22s2.108-.914 2.108-2.22m.02 3.879v-1.006c-.575.7-1.43 1.13-2.449 1.13-2.129 0-3.741-1.704-3.741-4.003 0-2.279 1.678-4.015 3.787-4.015.992 0 1.828.437 2.403 1.116v-.98h1.906v7.758h-1.906zM31.723 19.985c-.666 0-.856-.248-.856-.901v-3.441h1.228v-1.691h-1.228v-1.894h-1.952v1.894h-2.52v-.77c0-.654.248-.902.933-.902h.431v-1.502h-.94c-1.613 0-2.377.53-2.377 2.142v1.038h-1.084v1.685h1.084v6.066h1.952v-6.066h2.52v3.8c0 1.58.608 2.266 2.188 2.266h1.006v-1.724h-.385zM38.736 17.132c-.138-1.006-.96-1.613-1.927-1.613-.96 0-1.756.587-1.952 1.613h3.879zm-3.899 1.208c.137 1.149.96 1.802 2.005 1.802.823 0 1.456-.385 1.828-1.006h2.005c-.464 1.646-1.94 2.697-3.879 2.697-2.344 0-3.99-1.645-3.99-3.99 0-2.344 1.737-4.035 4.036-4.035 2.311 0 3.99 1.704 3.99 4.035 0 .17-.013.34-.046.497h-5.949zM53.264 17.83c0-1.253-.947-2.22-2.109-2.22s-2.11.934-2.11 2.22c0 1.274.948 2.22 2.11 2.22s2.11-.96 2.11-2.22m-6.145 7.046V13.952h1.906v1.005c.575-.711 1.43-1.149 2.449-1.149 2.096 0 3.742 1.724 3.742 4.003s-1.679 4.016-3.788 4.016c-.98 0-1.782-.386-2.344-1.039v4.081H47.12v.007zM62.092 17.83c0-1.306-.947-2.22-2.109-2.22s-2.109.934-2.109 2.22c0 1.274.947 2.22 2.11 2.22 1.161 0 2.108-.914 2.108-2.22m.02 3.879v-1.006c-.575.7-1.43 1.13-2.449 1.13-2.128 0-3.741-1.704-3.741-4.003 0-2.279 1.678-4.015 3.787-4.015.992 0 1.828.437 2.403 1.116v-.98h1.907v7.758h-1.907zM43.679 14.71s.483-.902 1.678-.902c.509 0 .835.176.835.176v1.979s-.718-.444-1.377-.353c-.66.092-1.078.692-1.078 1.502v4.59h-1.972v-7.75h1.907v.757h.007z"
            />
          </g>
        </svg>
        <span class="afterpay-info">ⓘ</span>
      </a>
    </p>
  </div>
</template>

<script>
import { getTagDiscount } from '../../../../utils/discount';
import { decimalPrice as decimalPriceUtility } from '../../../../utils/helpers/utility';

export default {
  name: 'ProductPrice',
  props: {
    product: {
      type: Object,
      required: true,
      default: {},
    },
    variant: {
      type: Object,
      required: true,
      default: {},
    },
    purchaseType: {
      type: String,
      default: 'onetime',
    },
    subscriptionDiscountedAmount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    currencySymbol() {
      return window.BPN?.cart?.currencySymbol || '$';
    },
    variantPrice () {
      return decimalPriceUtility(this.variant.price)
    },
    splitVariantPrice () {
      return decimalPriceUtility(this.variant.price / 4 )
    },
    compareAtPrice () {
      return decimalPriceUtility(this.product.compare_at_price)
    },
    tagDiscount() {
      return getTagDiscount(this.product.tags);
    },
    decimalSubscriptionDiscountedAmount () {
      return decimalPriceUtility(this.subscriptionDiscountedAmount)
    },
    discountedPrice() {
      const { tagDiscount, variant, product } = this;
      const priceInCents = variant?.price || product.price;

      if (tagDiscount) {
        const discountedPriceInCents = priceInCents - (priceInCents * tagDiscount / 100);
        return decimalPriceUtility(Math.round(discountedPriceInCents));
      }

      return decimalPriceUtility(priceInCents);
    },
  },
};
</script>
